import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

 export const useUpdateQueryParams = () => {
  const updateQueryParams = useCallback((params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    window.history.pushState({}, '', `?${searchParams.toString()}`);
  }, []);

  return updateQueryParams;
};
 
export const useReadQueryParams = (defaultConfig) => {
  const location = useLocation();

  const queryParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};

    Object.keys(defaultConfig).forEach(key => {
      const value = searchParams.get(key);
      if (value !== null) {
         if (typeof defaultConfig[key] === 'number') {
          params[key] = Number(value);
        } else if (typeof defaultConfig[key] === 'boolean') {
          params[key] = value === 'true';  
        } else {
          params[key] = value;
        }
      } else { 
        params[key] = defaultConfig[key];
      }
    });

    return params;
  }, [location.search, defaultConfig]);

  return queryParams;
};